"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HotSpotBox = props => {
  const {
    position = [0, 0, 0],
    args = [3, 5, 3],
    showBox = false,
    visible = true,
    children = null,
    pipe = ''
  } = props;
  return /*#__PURE__*/_react.default.createElement("group", {
    position: position,
    dispose: null,
    visible: visible
  }, showBox ? /*#__PURE__*/_react.default.createElement("mesh", {
    position: [0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement("boxGeometry", {
    args: args
  }), /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: pipe ? _constants.pipesColor[pipe] : '#FF0000',
    transparent: true,
    opacity: ".5"
  })) : null, _react.Children.map(children, child => {
    // Checking isValidElement is the safe way and avoids a typescript error too.
    if ( /*#__PURE__*/(0, _react.isValidElement)(child)) {
      // return cloneElement(child, { pipe, cardPosition: [position[0] + 3, position[1] + 10, position[2]] });
      return /*#__PURE__*/(0, _react.cloneElement)(child, {
        pipe,
        visible
      });
    }
    return child;
  }));
};
var _default = exports.default = HotSpotBox;